import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * 设置页面标题、描述和可选的规范链接。
 * @param {object} props 页面元数据
 * @param {string} props.title 页面标题
 * @param {string} [props.description] 页面描述
 * @param {string} [props.canonicalPath] 站内规范路径
 * @returns {JSX.Element} Helmet 元数据
 */
const MetaData = ({ title, description, canonicalPath }) => {
  const siteUrl = process.env.REACT_APP_SITE_URL || "https://www.creatyea.com";
  const canonicalUrl = canonicalPath
    ? `${siteUrl.replace(/\/$/, "")}${canonicalPath}`
    : null;

  return (
    <Helmet>
      <title>{`${title} - Creatyea`}</title>
      {description ? <meta name="description" content={description} /> : null}
      {canonicalUrl ? <link rel="canonical" href={canonicalUrl} /> : null}
    </Helmet>
  );
};

export default MetaData;
